// extracted by mini-css-extract-plugin
export var active = "slider-module--active--WHmKR";
export var dotitem = "slider-module--dotitem--eQUhA";
export var dotswrapper = "slider-module--dotswrapper--HKmbb";
export var leftbutton = "slider-module--leftbutton--trMPa";
export var rightbutton = "slider-module--rightbutton--Rr+Vy";
export var slide = "slider-module--slide--vg7wy";
export var top = "slider-module--top--dCVlW";
export var triangle = "slider-module--triangle--lYQJ6";
export var wrapper = "slider-module--wrapper--eWwOU";